import { useCallback, useSyncExternalStore } from "react";

// TODO: rewrite to zustand

const SPLASH_CTX = {
  fontsLoaded: false,
  sessionLoaded: false,
};

const calculateSplashActive = (ctx = SPLASH_CTX) => {
  return !ctx.fontsLoaded || !ctx.sessionLoaded;
};

let listeners: Array<() => void> = [];

export function useSplash() {
  const store = useSyncExternalStore(
    (listener) => {
      listeners = [...listeners, listener];
      return () => {
        listeners = listeners.filter((l) => l !== listener);
      };
    },
    () => calculateSplashActive(),
    () => calculateSplashActive()
  );

  const signalSplash = useCallback((newValue: Partial<typeof SPLASH_CTX>) => {
    Object.assign(SPLASH_CTX, newValue);
    listeners.forEach((l) => l());
  }, []);

  return {
    isSplashActive: store,
    signalSplash,
  };
}
